import type { BankRate } from "web_myplann/Calculators/Types/BankRate";

export const findLowestBankRate = (rates: BankRate[]) => {
	const offered = rates.filter((rate) => rate.status === "ok");

	if (offered.length === 0) {
		return undefined;
	}

	return offered.reduce((lowest, rate) =>
		rate.rate < lowest.rate ? rate : lowest,
	).rate;
};
